import React from 'react';

const Close: React.FC = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 18" fill="none" {...props}>
    <rect
      width="22.154"
      height="2.769"
      x="-0.504"
      y="15.93"
      fill="currentColor"
      rx="1.385"
      transform="rotate(-45 -.504 15.93)"
    ></rect>
    <rect
      width="22.154"
      height="2.769"
      x="1.455"
      y="0.265"
      fill="currentColor"
      rx="1.385"
      transform="rotate(45 1.455 .265)"
    ></rect>
  </svg>
);

export default Close;
